import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioLoanValueResponseDTO,
	type ClientPortfolioLoanValueSaveRequestDTO,
	putPortfolioIdManualValueLoansV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type LoanValueVariables = {
	portfolioId: number;
	request: ClientPortfolioLoanValueSaveRequestDTO;
};

export const usePutPortfolioManualValueLoansMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<
		ClientPortfolioLoanValueResponseDTO,
		Error,
		LoanValueVariables
	>({
		mutationFn: processResponse(({ portfolioId, request }) =>
			putPortfolioIdManualValueLoansV2(request, portfolioId),
		),
		onSuccess: (_, { portfolioId }) => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioList(),
			});
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.reporting(portfolioId),
			});
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioDetail(portfolioId),
			});
			queryClient.invalidateQueries({ queryKey: GoalsKeys.all });
		},
	});
};
